<template>
  <div>
    <modal :backdrop="false" size="max" v-model="modal">
      <div slot="header">
        <button @click.prevent="closeModal" class="close" type="button">×</button>
        <div class="row">
          <div class="item-header-nav"  v-for="tab in listTab" :class="{'active': selectedTab === tab.value}" @click="selectTab(tab.value)">
            {{tab.name}}
          </div>
        </div>
      </div>
      <div class="block-body">
        <div v-if="selectedTab === 'ID_PROOFING'">
          <ul class="itemlisttable  ptemr-list">
            <li class="itemlisthead">
              <div class="item-name">File Name</div>
              <div class="item-phone">Phone</div>
              <div class="item-kind">Type</div>
              <div class="item-status">Status</div>
            </li>
            <li v-if="isLoading" style="text-align: center; color: #d9df20; font-size: 16pt"><i
                class="fas fa-spinner fa-spin"></i></li>
            <li v-if="!isLoading && listFiles.length === 0" style="text-align: center; font-size: 16pt">
              No documents
            </li>
            <li v-if="!isLoading" class="item-doctor" v-for="(file) in listFiles">
              <div class="item-name" @click.prevent="showFile(file)">
                            <span v-if="!file.deleted_at">
                                  <span class="item-file-name">{{ file.fileName }}</span>
                                <img v-if="file.link && file.contentType && file.contentType.substr(0, 6) === 'image/'"
                                     :src="file.link" width="40"
                                     height="auto"/>
                            </span>
                <span v-if="file.deleted_at">File deleted</span>

              </div>
              <div class="item-phone">{{formatPhone(file.phone)}}</div>
              <div class="item-kind">
                {{ file.kindText }}
              </div>
              <div class="item-status">
                {{ file.statusText }}
<!--                <div v-if="!showButtonUpdateStatus(file)">-->
<!--                  <button class="btn btn-default btn-sm"-->
<!--                          style="margin-right: 5px"-->
<!--                          v-if="Number(file.status) !== 1"-->
<!--                          @click.prevent="changeStatusFile(file, 1)">-->
<!--                    &lt;!&ndash;<i class="fas fa-spinner fa-spin" v-if="processingStatus"></i>&ndash;&gt;-->
<!--                    ACCEPT-->
<!--                  </button>-->

<!--                  <button class=" btn btn-default btn-sm"-->
<!--                          v-if="Number(file.status) !== 2"-->
<!--                          @click.prevent="changeStatusFile(file, 2)">-->
<!--                    &lt;!&ndash;<i class="fas fa-spinner fa-spin" v-if="processingStatus"></i>&ndash;&gt;-->
<!--                    DENY-->
<!--                  </button>-->

<!--                </div>-->
<!--                <div v-else>-->
<!--                  {{ file.statusText }}-->
<!--                </div>-->
              </div>
            </li>
          </ul>
        </div>
        <div v-if="selectedTab === 'CREDENTIAL'">
          <div class="currentlist">
            <p class="credential-empty" v-if="listCredentials.length === 0">No file</p>
            <ul class="itemlisttable providerlist credential-list" v-if="listCredentials.length > 0">
              <li class="itemlisthead">
                <div class="credential-col credential-col-type">TYPE</div>
                <div class="credential-col credential-col-number">
                  LICENSE NUMBER
                </div>
                <div class="credential-col credential-col-expiration">EXPIRATION</div>
                <div class="credential-col credential-col-state">STATE</div>
                <div class="credential-col credential-col-main">MAIN LICENSE</div>
                <div class="credential-col credential-col-file">UPLOADED FILES</div>
              </li>
              <li v-for="item in listCredentials">
                <div class="credential-col credential-col-type">
                  {{ getTypeFile(item) }}
                </div>
                <div class="credential-col credential-col-number">
                  {{ item.type_number }}
                </div>
                <div class="credential-col credential-col-expiration">
                  {{ formatTime(item.expiration_date) }}
                </div>
                <div class="credential-col credential-col-state">
                  {{ item.state }}
                </div>
                <div class="credential-col credential-col-main">
                  <i class="fas fa-check-circle"
                     v-if="item.type !== 'abai_copy' && item.type !== 'abai' && item.main_number">
                  </i>
                </div>
                <div :title="item.file_name" class="credential-col credential-col-file">
                  <a href="javascript:void(0);"
                     @click="previewFile(item)">{{ item.file_name }}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="selectedTab === 'LICENSE'">
          <table class="table table-hover">
            <thead>
            <tr class="signed-form">
              <th class="td-type">TYPE</th>
              <th class="td-type-number">LICENSE NUMBER</th>
              <th class="td-date">EXPIRATION</th>
              <th class="td-state">STATE</th>
              <th class="td-main-number">MAIN LICENSE</th>
              <th class="td-name">UPLOADED FILES</th>
              <th class="td-action">From Clinic</th>
            </tr>
            </thead>
            <tbody>
            <tr class="signed-form" v-for="(file, index) in licenseFiles" :key="file.id">

              <td class="td-type">{{getTypeFileOfFile(file)}}</td>
              <td class="td-type-number">{{file.typeNumber}}</td>
              <td class="td-date">{{file.expirationDate}}</td>
              <td class="td-state">{{getStateOfFile(file)}}</td>
              <td class="td-main-number">
                <input v-if="file.typeFile === 'MEDICAL_LICENSE'" type="checkbox" disabled
                       :checked="file.isMain">
              </td>
              <td class="td-name">
                <div class="filename">
                  <img v-if="file.link && file.type.substr(0, 6) === 'image/'"
                       :src="formatLink(file.link)" width="40"
                       height="auto"/>
                  <span class="td-name-file-name">
                                            <a href="javascript:void(0)" @click.prevent="showFileLicense(file)"
                                               class="editFileName">
                                                 {{file.name}}
                                            </a>

                                    </span>
                </div>
              </td>
              <td class="td-action">
                {{ file.createFrom }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="selectedTab === 'Authentication'">
          <div v-if="!canSendLink">
            <div class="message-error-authentication" v-html="messageError"></div>
          </div>
          <div v-if="dataProofing.kycData && dataProofing.kycData.methods" class="block-verification" >
            <ul>
              <li v-for="item in dataProofing.kycData.methods">
                <div class="item-verification-method">{{ item.verificationMethod }}</div>
                <div class="item-status">{{ item.status }}</div>
                <div class="item-date-method">{{ formatFullTime12Hour(item.eventDate) }}</div>
              </li>
            </ul>

          </div>
          <div v-if="dataProofing.link && canSendLink" class="input-group">
            <input v-model="dataProofing.link" class="form-control input-field" readonly type="text">
            <div class="input-group-append">
              <button class="copy-btn" type="button" @click="copyToClipboard">
                Copy
              </button>
            </div>

            <div style="margin-top: 10px;" v-if="canSendLink">
            <span style="margin-right: 10px;">
              <input :id="'sms-type'" v-model="typeSends"
                     :value="'sms'"
                     name="send-type" type="checkbox">
            <label :for="'sms-type'">&nbsp;SMS {{ '(' + formatPhone(dataProofing.phone) + ')' }}</label>
            </span>

              <!--            <input :id="'email-type'" :value="'email'"-->
              <!--                   name="send-type"-->
              <!--                   type="checkbox" v-model="typeSends">-->
              <!--            <label :for="'email-type'">&nbsp;EMAIL {{'(' + dataProofing.email + ')'}}</label>-->
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button class="btn btn-default" type="button" @click.prevent="sendLinkIdProof"
                v-if="selectedTab === 'Authentication' && canSendLink">
          <i v-if="processingStatusAuthentication" class="fas fa-spinner fa-spin"></i> Send Link Id Proof
        </button>
        <button v-if="selectedTab === 'Authentication'
                && !dataProofing.enableIdProofing
                && canSendLink" class="btn btn-default"
                type="button"
                @click.prevent="enableIdProofing"
        >
          <i v-if="processingStatus" class="fas fa-spinner fa-spin"></i> Enable Id Proofing
        </button>
        <button @click.prevent="closeModal" class="btn btn-default" type="button">Close</button>
      </div>
    </modal>

    <preview-id-proof
        v-if="previewPdf.modal"
        :file="previewPdf.file"
        :typeFile="selectedTab"
        :needToAcceptDeny="previewPdf.needToAcceptDeny"
        @updateModal="previewPdf.modal = $event"
        @updateStatus="updateStatusUploadedFile"
    >
    </preview-id-proof>
    <preview-pdf
        v-if="previewPdfLicense.modal"
        :linkPreview="previewPdfLicense.link"
        @updateModal="previewPdfLicense.modal = $event">
    </preview-pdf>
  </div>

</template>

<script>
import httpClient from '../../../client'
import CommonMixin from '../../../mixins/general/CommonMixin.vue'
import PreviewIdProof from './PreviewIdProof.vue'
import PreviewPdf from '@/global/PreviewPdf'
import axios from '@/client'
import config from '@/config'
const baseUrl = config.baseUrl
export default {
  name: 'IdProofModal',
  components: { PreviewIdProof, PreviewPdf },
  props: {
    user: {},
    activeTab: {
      default: null
    }
  },
  mixins: [CommonMixin],
  data () {
    return {
      modal: false,
      listFiles: [],
      listCredentials: [],
      isLoading: true,
      previewPdf: {
        modal: false,
        file: null
      },

      processingStatus: false,

      selectedTab: 'ID_PROOFING',
      listTab: [
        { name: 'Cell phone bill', value: 'ID_PROOFING' },
        { name: 'User Uploaded Credentials', value: 'CREDENTIAL' },
        // { name: 'Clinic Uploaded Credentials', value: 'LICENSE' },
        { name: 'Authentication', value: 'Authentication' }
      ],
      licenseFiles: [],
      STATE: config.STATE,
      TYPE_FILE_OTHER: 'OTHER',
      LICENSE_TYPES: [
        { 'key': 'MEDICAL_LICENSE', 'name': 'Medical License' },
        { 'key': 'DEA', 'name': 'DEA' },
        { 'key': 'ABAI', 'name': 'ABAI' },
        { 'key': 'OTHER', 'name': 'Other' }
      ],
      dataTypeNumber: {
        'MEDICAL_LICENSE': 'Medical number',
        'DEA': 'DEA number',
        'ABAI': 'ABAI number'
      },
      previewPdfLicense: {
        modal: false,
        link: null,
        needToAcceptDeny: false,
        typeFile: ''
      },
      fileIdUpdateStatus: 0,
      processingStatusAuthentication: false,
      dataProofing: {
        link: '',
        enableIdProofing: false,
        kycData: null,
        phone: '',
        email: '',
        fullName: ''
      },
      dataUser: null,
      typeSends: []
    }
  },
  computed: {
    messageError () {
      if (this.canSendLink) {
        return ''
      }
      let messageError = ``
      if (!this.dataUser.birthday) {
        messageError += `Please update your birthday at your profile <br>`
      }
      if (!this.dataUser.email) {
        messageError += `Please update your email at your profile <br>`
      }
      if (!this.dataUser.firstName) {
        messageError += `Please update your First Name at your profile <br>`
      }
      if (!this.dataUser.lastName) {
        messageError += `Please update your Last Name at your profile <br>`
      }
      return messageError
    },
    canSendLink () {
      if (this.dataUser) {
        if (!this.dataUser.birthday || !this.dataUser.email || !this.dataUser.firstName || !this.dataUser.lastName) {
          return false
        }
      }
      return true
    }
  },
  watch: {
    'modal' (newValue, oldValue) {
      this.$emit('updateModal', newValue)
    }
  },
  updated () {
  },
  mounted () {
    this.modal = true
    this.getDataIdProof()
    this.getCredentialFiles()
    this.getInfoIdProofing()
    if (this.activeTab) {
      this.selectedTab = this.activeTab
    }
  },
  beforeDestroy () {
  },
  methods: {
    async updateStatus (file, statusUpdate, reasonCancel = '') {
      if (this.processingStatus) {
        return
      }
      try {
        let data = {
          id: file.id,
          status: statusUpdate,
          reason: reasonCancel
        }
        this.processingStatus = true
        let response = await httpClient.put(`/users/electronic-medical/update-status`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          file.status = statusUpdate
          file.user_action = {
            time: new Date(),
            action: statusUpdate,
            fullName: this.$store.state.user.fullName
          }
          this.$forceUpdate()
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error when update status ')
      }
    },
    previewFile (item) {
      this.previewPdf.file = item
      this.previewPdf.modal = true
      this.previewPdf.needToAcceptDeny = false
      this.fileIdUpdateStatus = item.id
    },
    getTypeFile (item) {
      let type = (item.type || item.typeFile || '').toLowerCase()
      if (type === 'medical_license') {
        return 'Medical License'
      }

      if (type === 'dea') {
        return 'DEA'
      }

      if (type === 'abai' || type === 'abai_copy') {
        return 'ABAI'
      }

      if (type === 'other') {
        return item.typeFileOther || item.type || item.typeFile
      }

      return item.type || item.typeFile
    },
    selectTab (selectTab) {
      this.selectedTab = selectTab
    },
    showButtonUpdateStatus (file) {
      return Number(file.status) !== 0 || file.deleted_at || file.kind === 'credit_card'
    },

    showFile (file) {
      if (!file || file.deleted_at) {
        return
      }
      this.previewPdf.file = file

      this.previewPdf.modal = true
    },
    async getCredentialFiles () {
      try {
        let params = { staffIdWiki: this.user.id }
        let response = await httpClient.get('/staff/file-upload', { params: params })
        if (response.data.s === 200) {
          let files = response.data.data.files || []
          this.listCredentials = files.map(file => this.normalizeCredentialFile(file))
          this.licenseFiles = this.listCredentials.map(file => this.normalizeLicenseFile(file))
          console.log('listCredentials', this.listCredentials)
          console.log('licenseFiles', this.licenseFiles)
        }
      } catch (e) {
        this.alertError(e.message)
      }
    },
    normalizeCredentialFile (file) {
      let filePath = file.filePath || ''
      let typeFile = file.typeFile || file.type || ''
      let expirationDate = file.expirationDate || file.expiration_date
      let name = file.name || file.file_name || ''
      return {
        ...file,
        _id: file._id || file.id,
        id: file._id || file.id,
        name: name,
        file_name: name,
        link: file.link || (filePath ? (baseUrl + '/file-imm/download-encode?view=true&name=' + filePath) : ''),
        linkDownload: file.linkDownload || (filePath ? (baseUrl + '/file-imm/download-encode?name=' + filePath) : ''),
        type: String(typeFile).toLowerCase(),
        typeFile: typeFile,
        type_number: file.typeNumber || file.type_number,
        expiration_date: expirationDate,
        main_number: file.isMain || file.main_number,
        status: file.status
      }
    },
    async getDataIdProof () {
      try {
        let params = { userId: this.user.id }
        let response = await httpClient.get(`/users/doctor/list-id-proof`, { params: params })
        this.isLoading = false
        if (response.data.s === 200) {
          this.listFiles = response.data.data.files
        }
      } catch (e) {
        console.log(e.message)
      }
    },
    getLicenseFiles () {
      axios.get('/staff/file-upload', {
        params: {
          staffIdWiki: this.user.id
        }
      }).then(response => {
        if (response.data.s === 200) {
          let data = response.data.data
          this.licenseFiles = []
          data.files.map(file => {
            this.licenseFiles.push({
              _id: file._id,
              id: file._id,
              name: file.name,
              link: '/file-imm/download-encode?view=true&name=' + file.filePath,
              linkDownload: '/file-imm/download-encode?name=' + file.filePath,
              type: file.mimeType || '',
              createdAt: file.createdAt,
              state: file.state,
              typeFile: file.typeFile,
              typeFileOther: file.typeFileOther,
              typeNumber: file.typeNumber,
              expirationDate: file.expirationDate,
              isMain: file.isMain,
              createFrom: file.createFrom
            })
          })
        } else {
          // this.alertError(response.data.msg)
        }
      }).catch(e => {
        this.alertError(e.message)
      })
    },
    normalizeLicenseFile (file) {
      return {
        _id: file._id,
        id: file._id || file.id,
        name: file.name,
        link: file.link,
        linkDownload: file.linkDownload,
        type: file.mimeType || '',
        createdAt: file.createdAt,
        state: file.state,
        typeFile: file.typeFile,
        typeFileOther: file.typeFileOther,
        typeNumber: file.typeNumber || file.type_number,
        expirationDate: file.expirationDate || file.expiration_date,
        isMain: file.isMain || file.main_number,
        createFrom: file.createFrom
      }
    },
    closeModal () {
      this.modal = false
    },
    getStateOfFile (file) {
      if (file.state) {
        let index = this.STATE.findIndex(item => item.code === file.state)
        if (index > -1) {
          return this.STATE[index].name
        }
        return file.state
      }
      return ''
    },
    getTypeFileOfFile (file) {
      let typeFileText = ''
      if (file.typeFile) {
        if (file.typeFile === this.TYPE_FILE_OTHER) {
          typeFileText = file.typeFileOther
        } else {
          let index = this.LICENSE_TYPES.findIndex(item => item.key === file.typeFile)
          if (index > -1) {
            typeFileText = this.LICENSE_TYPES[index].name
          } else {
            typeFileText = file.typeFile
          }
        }
      }
      return typeFileText
    },
    formatLink (link) {
      if (link.includes('data:image')) {
        return link
      }
      return baseUrl + link
    },
    showFileLicense (file) {
      this.previewPdfLicense.link = this.formatLink(file.link)
      this.previewPdfLicense.modal = true
    },
    updateStatusUploadedFile (data) {
      this.updateStatus(data.file, data.statusUpdate == 1 ? 'verified' : 'rejected', (data.reasonCancel ? data.reasonCancel : ''))
      this.previewPdf.modal = false
    },
    async sendLinkIdProof () {
      if (this.processingStatus) {
        return
      }
      if (this.typeSends.length === 0) {
        this.alertError('Please choose type of sending')
        return
      }
      try {
        let data = {
          userId: this.user.id,
          typeSends: this.typeSends
        }
        this.processingStatus = true
        let response = await httpClient.post(`/users/send-id-proofing`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          this.alertSuccess(response.data.msg)
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error')
      }
    },
    async copyToClipboard () {
      await navigator.clipboard.writeText(this.dataProofing.link)
    },
    async getInfoIdProofing () {
      try {
        let response = await httpClient.get(`/users/id-proofing-state/${this.user.id}`)
        if (response.data.s === 200) {
          this.dataProofing.enableIdProofing = response.data.data.enableIdProofing
          this.dataProofing.link = response.data.data.link
          this.dataProofing.kycData = response.data.data.kycData
          this.dataProofing.phone = response.data.data.phone
          this.dataProofing.email = response.data.data.email
          this.dataProofing.fullName = response.data.data.fullName
          this.dataUser = response.data.data.user
        } else {
          this.alertError(response.data.msg)
          this.modal = false
        }
      } catch (e) {
        this.alertError(e.message)
      }
    },
    async enableIdProofing () {
      if (this.processingStatus) {
        return
      }
      try {
        let data = {
          userId: this.user.id
        }
        this.processingStatus = true
        let response = await httpClient.put(`/users/enable-id-proofing`, data)
        this.processingStatus = false
        if (response.data.s === 200) {
          this.dataProofing.link = response.data.data.link
          this.dataProofing.enableIdProofing = true
        } else {
          this.alertError(response.data.msg)
        }
      } catch (e) {
        this.processingStatus = false
        this.alertError('Server error')
      }
    }
  }
}
</script>
<style scoped="">
.item-file-name {
  display: inline-block;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 5px;
}

.item-name {
  width: 40% !important;
  cursor: pointer;
  min-height: 1px;
}
.item-phone {
  width: 15% !important;
  cursor: pointer;
  min-height: 1px;
}

.item-kind {
  width: 15% !important;
  min-height: 1px;

}

.item-status {
  width: 30% !important;
  min-height: 1px;
  padding-right: 5px;
}

.item-action {
  width: 10% !important;
  text-align: right;
  padding-right: 10px;
  float: right;
}

.item-header-nav {
  cursor: pointer;
  text-align: center;
  min-width: 150px;
  display: inline-block;
  background: #ebebeb;
  padding: 10px 15px;
  font-weight: bold;
  margin-bottom: 10px;
  border: 1px solid #ebebeb !important;
}

.item-header-nav.active {
  background: white !important;
  color: #bec500;
}

.credential-empty {
  text-align: center;
}

.credential-list .credential-col {
  min-height: 1px;
  padding-top: 0 !important;
}

.credential-col-type {
  width: 15% !important;
}

.credential-col-number {
  width: 16% !important;
  padding-left: 0 !important;
  text-align: center !important;
}

.credential-col-expiration {
  width: 13% !important;
  text-align: center;
}

.credential-col-state {
  width: 10% !important;
  text-align: center;
}

.credential-col-main {
  width: 15% !important;
  text-align: center;
}

.credential-col-file {
  width: 31% !important;
  text-align: center;
}

.item-verify {
  width: 25% !important;
  text-align: center;
  padding-top: 0px !important;
  cursor: pointer;
  text-transform: capitalize;
}

.td-name {
  width: 22% !important;
}

.td-type {
  width: 15% !important;
  text-align: left;
}

.td-date {
  width: 10% !important;
  text-align: left;
}

.td-state {
  width: 8%;
  text-align: left;
  min-height: 1px;
}

.td-action {
  width: 25% !important;
  color: black !important;
  text-align: right;
  min-height: 1px;
}

.td-type-number {
  width: 15% !important;
  text-align: left;
  min-height: 1px;
}

.td-main-number {
  width: 12% !important;
  text-align: center;
  min-height: 1px;
}

.td-action a {
  color: black !important;
}

/* Style for input group */
.input-group {
  position: relative;
  width: 75% !important;
}

/* Style for input field */
.input-field {
  border-radius: 5px;
  width: 100%;
}

.item-verification-method {
  width: 30%;
  display: inline-block;
}

.item-status {
  padding-left: 10px;
  width: 30%;
  display: inline-block;
}

.item-date-method {
  width: 30%;
  display: inline-block;
}

/* Style for copy button */
.copy-btn {
  position: absolute;
  right: -70px;
  top: 6px;
  border: none;
  background-color: #d9df20;
  color: white;
  padding: 8px 12px;
  font-size: 16px;
  cursor: pointer;
  z-index: 999999999999999999999;
}

/* Style for copy button on hover */
.copy-btn:hover {
  background-color: #3e8e41;
}
.message-error-authentication {
  color: red;
}
</style>
